import { render } from "./Registration.vue?vue&type=template&id=4aca4897"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\bdroyelculture-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__